import React from 'react';
import { Box } from '@material-ui/core';
// import MainNavbar from './MainNavbar';

export const MainLayout = (Component, key) => {
  return (
    <React.Fragment key={key}>
      {/* <MainNavbar /> */}
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" style={{ marginTop: 20 }}>
        {Component}
      </Box>
    </React.Fragment>
  );
};
